import { render } from "./EditingCanvas.vue?vue&type=template&id=3966f14a&scoped=true"
import script from "./EditingCanvas.vue?vue&type=script&lang=js"
export * from "./EditingCanvas.vue?vue&type=script&lang=js"

import "./EditingCanvas.vue?vue&type=style&index=0&id=3966f14a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3966f14a"]])

export default __exports__